import type { AssetFolderDoc } from '@bb/domain/dist/schemas';
import axios from 'axios';

export const saveFolder = async (
  folder: Partial<AssetFolderDoc>,
): Promise<AssetFolderDoc> => {
  const { data } = await axios.post('/asset/folder', folder);
  return data;
};
